import React from "react";
import { connect } from "react-redux";
import IntervalSelector from "components/atoms/intervalSelector/index.jsx";
import { fillFiltersFromStock, fillFilters } from "../filter/helpers";
import { filterStock } from "actions/stock";

import "./styles.scss";

class ListFilter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      options: props.values
        ? fillFilters(props.values)
        : fillFiltersFromStock(props.stock, props.attribute),
    };
    this.openOptions = this.openOptions.bind(this);
    this.selectInterval = this.selectInterval.bind(this);
    this.selectOption = this.selectOption.bind(this);
  }

  componentDidUpdate() {
    if (!this.state.options?.length) {
      this.setState({
        options: fillFiltersFromStock(this.props.stock, this.props.attribute),
      });
    }
  }

  selectOption(e, option) {
    e.preventDefault();

    if (typeof option === "object") {
      this.selectInterval(option);
      return;
    }

    if (option === this.props.filters[this.props.attribute]) {
      option = null;
    }

    this.props.filter(this.props.attribute, option);
  }

  selectInterval(interval) {
    if (
      (!interval.min && !interval.max) ||
      this.state.selectedInterval === interval
    ) {
      interval = null;
    }

    this.setState({ selectedInterval: interval });

    this.props.filter(this.props.attribute, interval);
  }

  openOptions(e) {
    e.preventDefault();

    this.setState({
      open: true,
    });
  }

  render() {
    const mainOptions = this.state.options.slice(0, 4);
    const value = this.props.filters[this.props.attribute];

    return (
      <div className={"listFilter"}>
        <h4 className="listFilter__title">{this.props.label}</h4>
        <div className="values">
          {!this.props.interval &&
            this.state.open &&
            this.state.options.map((option, i) => {
              const selected = value === option;

              return (
                <div
                  className={"value " + (selected ? "selected" : "")}
                  key={i}
                  onClick={(e) => this.selectOption(e, option)}
                >
                  {typeof option === "object" ? option.label : option}
                </div>
              );
            })}
          {(!this.state.open || this.props.interval) &&
            mainOptions.map((option, i) => {
              const selected = value === option;

              return (
                <div
                  className={"value " + (selected ? "selected" : "")}
                  key={i}
                  onClick={(e) => this.selectOption(e, option)}
                >
                  {typeof option === "object" ? option.label : option}
                </div>
              );
            })}

          {this.state.open && this.props.interval && (
            <IntervalSelector apply={this.selectInterval} />
          )}
        </div>
        {!this.state.open && this.state.options.length > 3 && (
          <div className="options">
            <span className="option" onClick={this.openOptions}>
              Ver más
            </span>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    stock: state.stock.allItems,
    filters: state.stock.filters,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    filter: (attribute, value) => {
      dispatch(filterStock(attribute, value));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ListFilter);
